document.addEventListener("DOMContentLoaded", function () {
  var myForm = document.getElementById("basin");
  myForm.addEventListener("submit", function (event) {
    event.preventDefault();

    grecaptcha.ready(function () {
      grecaptcha
        .execute("6Les66kUAAAAANyLrgkl7iuN4JUpNlB5upaMovI4", {
          action: "submit",
        })
        .then(function (token) {
          document.getElementById("g-recaptcha-response").value = token;
          myForm.submit();
        });
    });
  });
});
